var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.suffix, _vm.icon],style:({
    fontSize: `${_vm.size}px`,
  }),on:{"click":_vm.handleClick}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }